import { render } from "./doctor-changepassword.vue?vue&type=template&id=0be84392&scoped=true"
import script from "./doctor-changepassword.vue?vue&type=script&lang=js"
export * from "./doctor-changepassword.vue?vue&type=script&lang=js"

import "./doctor-changepassword.vue?vue&type=style&index=0&id=0be84392&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be84392"]])

export default __exports__